import React from 'react';
import { Container, Typography, Box } from '@mui/material';
import CodigoBarrasForm from '../components/codigoBarras/CodigoBarrasForm';

const CodigoBarrasNovo: React.FC = () => {
  return (
    <Container maxWidth="md" sx={{ mt: 4, mb: 4 }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
        <Typography 
          variant="h4" 
          component="h1" 
          gutterBottom 
          sx={{ 
            fontWeight: 'bold',
            fontFamily: 'Arial, sans-serif',
            fontSize: '2.125rem',
            lineHeight: 1.235
          }}
        >
          Novo Código de Barras
        </Typography>
      </Box>
      <CodigoBarrasForm isEdit={false} />
    </Container>
  );
};

export default CodigoBarrasNovo;
